module.exports = __webpack_public_path__ + "static/media/huawei_fr.a48334f2.png";